// extracted by mini-css-extract-plugin
module.exports = {"TabButton":"class-component_TabButton__1F7NO","TabButtonClicked":"class-component_TabButtonClicked__1horM"};